// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map {
  margin-right: 10px;
}

.map-row {
  min-height: 40vh;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.properties-table {
  height: 92.5vh;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
